// extracted by mini-css-extract-plugin
module.exports = {"component":"Gatsby-module--component--3X20x","logo":"Gatsby-module--logo--3kcN6"};